import React, { createContext, useState, useContext } from "react";

const RouteContext = createContext();

export const RouteProvider = ({ children }) => {
  const [previousRoute, setPreviousRoute] = useState("");

  return (
    <RouteContext.Provider value={{ previousRoute, setPreviousRoute }}>
      {children}
    </RouteContext.Provider>
  );
};

export const useRoute = () => useContext(RouteContext);
